export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatPhoneNumber = (value) => {
  if (value === null || value === undefined) {
    return "";
  } else {
    let onlyNumbers = value.replace(/[^0-9]/g, "");
    let numberArray = onlyNumbers.split("");
    if (numberArray.length > 9) {
      let formatedNumber =
        "(" +
        numberArray[0] +
        numberArray[1] +
        numberArray[2] +
        ") " +
        numberArray[3] +
        numberArray[4] +
        numberArray[5] +
        "-" +
        numberArray[6] +
        numberArray[7] +
        numberArray[8] +
        numberArray[9];
      return formatedNumber;
    } else {
      return value;
    }
  }
};

export const formatDate = (dateInput, options = {}) => {
  if (!dateInput) return null;

  let date;
  // Check if the input is a number or a numeric string (timestamp)
  if (typeof dateInput === 'number' || (typeof dateInput === 'string' && /^\d+$/.test(dateInput))) {
    date = new Date(parseInt(dateInput, 10));
  } else {
    // Otherwise, try to parse it as a date string or assume it's a Date object
    date = new Date(dateInput);
  }

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const defaultOptions = {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true
  };

  const formatOptions = { ...defaultOptions, ...options };
  return date.toLocaleString("en-US", formatOptions);
};
